import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "base_screen_header"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1);

const _hoisted_3 = {
  class: "base_main_margin_top"
};
import StatusBar from "@com/StatusBar.vue";
import ExamineTable from '@com/examine/ExamineTable.vue';
import { ref, reactive } from "vue";
import { Search } from "@element-plus/icons-vue";
import useRoute from "@util/router";
import api from "@api/examine";
export default {
  __name: 'LineExamine',

  setup(__props) {
    const config = {
      type: 'line'
    };
    const route = useRoute();
    const data = ref([]);
    const total = ref(0);
    route.watchRouter("lineexamine", () => {
      getStatistics();
      getList();
    });
    const statusList = reactive([{
      label: '全部',
      value: 'all',
      total: 0
    }, {
      label: '待审批',
      value: '1007002',
      total: 0
    }, {
      label: '已通过',
      value: '1007004',
      total: 0
    }, {
      label: '已驳回',
      value: '1007003',
      total: 0
    }]);
    getList();

    function getList() {
      let routeQuery = route.query();
      api.list(config.type, {
        flowStatus: routeQuery.status,
        page: routeQuery.p,
        size: routeQuery.s
      }, val => {
        total.value = val.total;
        data.value = val.list.map(e => {
          // 1007001草稿 1007002待审批 1007003被驳回 1007004审批通过
          switch (e.flowStatus) {
            case "1007001":
              e.state = "草稿";
              break;

            case "1007002":
              e.state = "待审批";
              break;

            case "1007003":
              e.state = "已驳回";
              break;

            case "1007004":
              e.state = "已通过";
              break;
          }

          return e;
        });
      });
    }

    getStatistics();

    function getStatistics() {
      api.lineNum(val => {
        statusData(val);
      });
    }

    function statusData(val) {
      statusList.forEach((e, i) => {
        e.total = val[i];
      });
    }

    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_main = _resolveComponent("el-main");

      return _openBlock(), _createBlock(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item)]),
          _: 1
        })]), _createVNode(StatusBar, {
          data: statusList,
          default: "all"
        }, null, 8, ["data"]), _createElementVNode("div", _hoisted_3, [_createVNode(ExamineTable, {
          type: config.type,
          data: data.value,
          total: total.value,
          onGetData: getList
        }, null, 8, ["type", "data", "total"])])]),
        _: 1
      });
    };
  }

};